import { render, staticRenderFns } from "./VolumeBox.vue?vue&type=template&id=99e79934&scoped=true"
import script from "./VolumeBox.vue?vue&type=script&lang=js"
export * from "./VolumeBox.vue?vue&type=script&lang=js"
import style0 from "./VolumeBox.vue?vue&type=style&index=0&id=99e79934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e79934",
  null
  
)

export default component.exports